// extracted by mini-css-extract-plugin
export default {"tabs":"Ouqzesj5kuwDIn23py8cvA=="};